// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2i-1";
export var rateTableServiceLevelDropdown = "_2i-3";
export var rateTableTypeDropdown = "_2i-0";
export var rateTableValueModeDropdown = "_2i-2";